import { Divider, Stack } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { getLinearSettings, isLinearSettings } from "../../../../viewer/chart/helper.ts";
import StyleGroup from "../../../../viewer/chart/StyleGroup.tsx";
import { selectChartSettingsState } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import ValueAxisItem from "./ValueAxisItem.tsx";

export default function ValueAxisStyles({ readonlyMode }: { readonlyMode: boolean }) {
  const settingsArea = useSelector(selectChartSettingsState);
  const settings = React.useMemo(() => getLinearSettings(settingsArea), [settingsArea]);
  const supported = React.useMemo(() => isLinearSettings(settingsArea), [settingsArea]);

  if (!supported) {
    return <></>;
  }

  return (
    <StyleGroup caption="Value Axes">
      <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
        {settings?.valueAxis?.map((axis, index) => {
          const lastSerie = settings?.valueAxis?.length === index + 1;
          const serieItem = (
            <ValueAxisItem key={axis.name} settings={settingsArea} axis={axis} readonlyMode={readonlyMode} />
          );
          if (!lastSerie) {
            return [serieItem, <Divider key={`Divider_values_${axis.name}`} sx={{ borderStyle: "dashed" }} />];
          }
          return serieItem;
        })}
      </Stack>
    </StyleGroup>
  );
}
